import React from 'react'
import {Col, Form, Row} from "react-bootstrap";
import Api from "../../../helpers/Api";
import SubmitButton from "../components/SubmitButton";
import DataStore from "../../../helpers/DataStore";
import Heading from "../../../Components/Heading/Heading";

class ImageForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            post: {},
            files: [],
        }
    }

    componentDidMount() {

        let {match: {params}} = this.props;
        if (params.id) {
            this.loadData(params.id);
        }
    }

    loadData = (id) => {
        if (id === 'new') {
            return;
        }
        Api.call(`/images/${id}`).then(post => {
            this.setState({post});
        }).catch(console.log).finally(() => {
            this.setState({loading: false});
        });
    };

    validate = () => {
        let {post} = this.state;
        return true;
    };

    submit = (e) => {
        e.preventDefault();
        if (!this.validate()) {
            return;
        }
        if (this.state.post.id) {
            this.update();
        } else {
            this.create();
        }
    };

    randomInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    update = () => {
        this.setState({loading: true});
        let {post, files} = this.state;

        if (post.category) {
            post.category = post.category.id;
        }
        if(this.state.image){
            post.image = this.state.image;
        }

//        post.author = DataStore.getUser().id;
        //let file = files.thumbnail;



        Api.call(`/images/${this.state.post.id}`, "POST", JSON.stringify(post), true).then(post => {
            this.setState({post: post});
            this.props.history.push('/app/images');
        }).catch(console.log).finally(() => {
            this.setState({loading: false});
        })
    };
    create = () => {
        this.setState({loading: true});
        let {post, files} = this.state;

        if (post.category) {
            post.category = post.category.id;
        }

        if(this.state.image){
            post.image = this.state.image;
        }

        Api.call(`/images`, "POST", JSON.stringify(post), true).then(post => {
            this.setState({post: post});
            this.props.history.push('/app/images');
        }).catch(console.log).finally(() => {
            this.setState({loading: false});
        })
    };
    onChange = (key, value) => {
        console.log(key, value);
        let {post} = this.state;
        post[key] = value;
        let length = 50;
        this.setState({post: post});
    };

    onFileChange = (key, value) => {
        if (!value) {
            this.setState({
                image: null
            });
            return;
        }
        console.log(key, value);
        let {files} = this.state;
        files[key] = value;
        var reader = new FileReader();

        this.setState({files: files});
        reader.readAsDataURL(value);

        reader.onloadend = function (e) {
            this.setState({
                image: [reader.result]
            });
        }.bind(this);
    };

    getImageUrl = (post) => {
        return Api.getImageUrl(post.imageUrl, false);
    };

    render() {
        let {post} = this.state;
        let imageUrl = this.getImageUrl(post);
        return (
            <div className="dashboard">

                <Heading name="Edit"/>

                <div style={{marginTop: '70px'}}>
                    <Row>
                        <Col md={6}>
                            <Form autoComplete={'off'} onSubmit={this.submit}>

                                <Form.Group controlId="thumbnail">
                                    <Form.Label>Image</Form.Label>
                                    <Form.Control type="file"
                                                  onChange={event => this.onFileChange('image', event.target.files[0])}/>
                                </Form.Group>


                                {imageUrl &&
                                <><img src={imageUrl} width={200} alt='Image'/><br/></>
                                }


                                <Form.Group controlId="enabled">
                                    <Form.Check type="checkbox" checked={post.enabled}
                                                onChange={event => this.onChange('enabled', event.target.checked)}
                                                label="Enabled"/>
                                </Form.Group>
                                <SubmitButton label={'Submit'} loading={this.state.loading}/>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default ImageForm
